var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 38H24.9999C24.9999 38 24.9999 29.718 24.9999 23H29.453L30.0001 16.9999H25.2322V14.6009C25.2322 13.4318 26.0114 13.16 26.5583 13.16C27.1051 13.16 29.9242 13.16 29.9242 13.16V8.01883L25.2891 8C20.1441 8 18.9751 11.834 18.9751 14.2879V16.9999H16V23H18.9999C18.9999 29.799 18.9999 38 18.9999 38Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.26a99b927c52894e9fbee7bb9ce92640.svg";
export { ForwardRef as ReactComponent };